import {MetricConfiguration} from "areas/metrics/components/MetricSelector/types";
import {MetricInfo} from "framework/entities/metricInfo";
import {getUnitType} from "areas/metrics/components/MetricSelector/utils/getUnitType";
import {formatNumber} from "tools/helpers/math";

export type ValueFormatter = (value: number) => string

export function getValueFormatter(metricConfiguration: MetricConfiguration, metric: MetricInfo): ValueFormatter {
	return (value: number) => {
		return `${formatNumber(value, metricConfiguration.decimals)} ${getUnitType(metricConfiguration, metric)}`
	}
}
